import { propertyUtils } from '@zg-rentals/rental-manager-env';
import { Alert, Box } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';
import accessUtils from '../../../../utils/accessUtils';

import PropertyDescriptionFormField from './PropertyDescriptionFormField';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const baseHeading = 'Describe the property';

const baseBodyText =
  'Write several sentences describing the upgrades and desirable features that will attract renters to your property.';

const roomForRentHeading = 'Describe the room and shared spaces';

const roomForRentBodyText =
  'Write several sentences describing the room and shared spaces, being sure to mention desirable features that may attract renters.';

const getBodyContent = ({ isRoomForRent }: { isRoomForRent: boolean }) => {
  let bodyContent;

  if (isRoomForRent) {
    bodyContent = roomForRentBodyText;
  } else {
    bodyContent = baseBodyText;
  }

  return bodyContent;
};

const FormSectionContainer = () => {
  const currentProperty = useSelector((state) => state.properties.currentProperty);

  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });
  const shouldShowBrokerFeeAlert = accessUtils.shouldShowBrokerFeeAlert({
    state: currentProperty.state,
  });

  const heading = isRoomForRent ? roomForRentHeading : baseHeading;
  const bodyContent = getBodyContent({ isRoomForRent });

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      <WizardHeading textStyle="heading-sm" level={1}>
        {heading}
      </WizardHeading>

      <WizardBody>{bodyContent}</WizardBody>

      {shouldShowBrokerFeeAlert && (
        <Box css={{ marginBottom: '400' }}>
          <Alert tone="info">
            <strong>MA Broker Fee Rule:</strong> Starting Aug 1, broker fees can be charged only to tenants who directly
            hire a broker
          </Alert>
        </Box>
      )}

      <PropertyDescriptionFormField />
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
